<div class="header" >
    <span class="header-title"><strong>{{'PROFILE_PAGE.ADD_CUSTOMER' | i18nTranslate}}</strong></span>
    <mat-dialog-actions>
      <button class="xIcon" mat-dialog-close><div class="material-icons" style="margin-left: -4.5px;
        font-size: 15px;">clear</div></button>
    </mat-dialog-actions>
  </div>
  <div>
    <div class="selectDomainName-user">
      <div style="display: flex; flex-direction: row; gap: 10px;">
        <div style="display: flex; flex-direction: column;">
          <span class="filterTitle">{{'PROFILE_PAGE.FIRST_NAME' | i18nTranslate}} <span class="qb-imp-color">*</span></span> 
          <input type="text" [(ngModel)]="name" (keydown)="keypress()">
          <div *ngIf="errorName.length > 0" style="color: red; font-size: 11px;">{{errorName}}</div>
        </div>

        <div style="display: flex; flex-direction: column;">
            <span class="filterTitle">{{'PROFILE_PAGE.LAST_NAME' | i18nTranslate}}</span>
            <input type="text" [(ngModel)]="lastname" (keydown)="keypress()">
            <div *ngIf="errorLastName.length > 0" style="color: red; font-size: 11px;">{{errorName}}</div>
          </div>
      </div>
      <div style="display: flex; flex-direction: row;  gap: 10px;">

        <div style="display: flex; flex-direction: column;">
            <span class="filterTitle">{{'PROFILE_PAGE.EMAIL' | i18nTranslate}} <span class="qb-imp-color">*</span></span> 
            <input type="text" [(ngModel)]="email" (keydown)="keypress()">
            <div *ngIf="errorMail.length > 0" style="color: red; font-size: 11px;">{{errorMail}}</div>
          </div>

        <div style="display: flex; flex-direction: column;">
          <span class="filterTitle">{{'PROFILE_PAGE.PHONE_NUMBER' | i18nTranslate}}</span>
          <div class="qb-d-flex">
            <div class="qb-input-field" style="width: 276px;">
              <input class="input" type="text"
              ng2TelInput
              [ng2TelInputOptions]="{onlyCountries: [country]}"
              (ng2TelOutput)="getNumber($event)"
              (intlTelInputObject)="telInputObject($event)"
              (countryChange)="onCountryChange($event)" 
              (input)="onInputChange()"
              />
            </div>
          </div>
          <div *ngIf="phoneNumberErrorText.length > 0" style="color: red; font-size: 11px;">{{phoneNumberErrorText}}</div>
        </div>
  
      </div>

     


      <div style="display: flex; flex-direction: row; gap: 10px;">
        <div style="display: flex; flex-direction: column;">
          <span class="filterTitle">{{'CUSTOMER_PAGE.DATE_OF_BIRTH' | i18nTranslate}}</span>
            <div class="formDiv-customer">
              <input
                style="margin-left: 5%"
                [(ngModel)]="dateOfBirth"
                class="formInput fs08-rem"
                matInput
                [matDatepicker]="picker1"
                placeholder="Choose date of Birth"
                [max]="startDateMinValue"
                readonly
                [ngStyle]="dateOfBirth ? { opacity: 0, width: '0px' } : null"
              />
              <div class="formInput fs08-rem" *ngIf="dateOfBirth">
                {{ dateOfBirth | date : getDateFormat() }}
              </div>
              <mat-datepicker-toggle matSuffix [for]="picker1">
              </mat-datepicker-toggle>
              <mat-datepicker #picker1></mat-datepicker>
            </div>
        </div>

        <div style="display: flex; flex-direction: column;">
          <span class="filterTitle">{{'CUSTOMER_PAGE.ANNIVERSARY' | i18nTranslate}}</span>
            <div class="formDiv-customer">
              <input
                style="margin-left: 5%"
                [(ngModel)]="anniversary"
                class="formInput fs08-rem"
                matInput
                [matDatepicker]="picker2"
                placeholder="Choose Anniversary"
                [max]="startDateMinValue"
                readonly
                [ngStyle]="anniversary ? { opacity: 0, width: '0px' } : null"
              />
              <div class="formInput fs08-rem" *ngIf="anniversary">
                {{ anniversary | date : getDateFormat() }}
              </div>
              <mat-datepicker-toggle matSuffix [for]="picker2">
              </mat-datepicker-toggle>
              <mat-datepicker #picker2></mat-datepicker>
            </div>
        </div>
      </div>

      <div style="display: flex; flex-direction: row; gap: 10px;">
        <div style="display: flex; flex-direction: column;">
          <span class="filterTitle">{{'CUSTOMER_PAGE.GENDER' | i18nTranslate}}</span>
          <mat-select
          placeholder="{{ 'CUSTOMER_PAGE.SELECT_GENDER' | i18nTranslate }}"
          [(ngModel)]="gender"
          class="input">
          <mat-option *ngFor="let gender of genderList" [value]="gender">
            {{ gender }}
          </mat-option>
        </mat-select>
        </div>
      </div>

    </div>
    </div>
    
    <div class="buttons">
      <mat-dialog-actions>  
        <button class="cancel secondary-button-border" (click)="submit()" data-button-name="Canceled">{{'PROFILE_PAGE.CANCEL' | i18nTranslate}}</button>
      </mat-dialog-actions>
      <mat-dialog-actions >
        <button class="confirm primary-button" (click)="add()" data-button-name="Confirm: User Added" [attr.data-item-name]="email" *ngIf="!apiloading"> {{'PROFILE_PAGE.CREATE' | i18nTranslate}}</button>
        <button class="confirm secondary-button" style="width: 76px; justify-content: center;" *ngIf="apiloading"><mat-spinner diameter="15"></mat-spinner></button>
      </mat-dialog-actions>
    </div>